(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreButton = document.querySelector('.load-more');
    const contentContainer = document.querySelector('.products-grid');
    const collectionUrl = document.getElementById('product-list').dataset.collectionUrl;
    let loading = false;

    loadMoreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loading) return;

      loading = true;
      loadMoreButton.textContent = 'Loading...';

      fetch(`${loadMoreButton.dataset.nextUrl}`)
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const parsedContent = parser.parseFromString(data, 'text/html');
          const newContent = parsedContent.querySelectorAll('.product-grid .product-item');
          const nextPagination = parsedContent.querySelector('.load-more')?.dataset.nextUrl;
          contentContainer.append(...newContent);
          loading = false;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.dataset.nextUrl = nextPagination;

          if (!nextPagination) {
            loadMoreButton.style.display = 'none';
          }
        })
        .catch((error) => {
          console.error('Error loading more products:', error);
          loading = false;
          loadMoreButton.textContent = 'Load More';
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
